type LawsuitItemType = "CTE_LAWSUIT" | "CTE_CASE";

export type LawsuitItemTypeMap = {
  [Property in LawsuitItemType]: string;
};

export type LawsuitListItem = {
  id: number;
  status: "ACTIVE" | "INACTIVE";
  title: string;
  type: LawsuitItemType;
  lawsuitType?: string;
  instanceNumber?: number;
};

export type LawsuitListFetch = {
  count: number;
  cursor: string;
  lawsuits: LawsuitListItem[];
  total: number;
};

export type LawsuitListCountFetch = {
  count: number;
};

export type CaseCustomer = {
  name: string;
  id: number;
  role: number;
  main: boolean;
  roleName: string;
  roleType: number;
  title: number;
};

export type LawsuitAttachment = {
  title: string;
  id: number;
  canSee: boolean;
};

export type Stakeholder = {
  stakeholderRoleName: string;
  stakeholderRoleId: number;
  contactId: number;
  contactName: string;
  roleType: number;
};

export type LawsuitAppealIncident = {
  automatic: boolean;
  caseType: "CTE_INCIDENT" | "CTE_APPEAL";
  createdAt: number;
  id: number;
  lawsuit: {
    instanceNumber: number;
    lawsuitTypeName: string;
    status: string;
  };
  parentCaseId: number;
  rootCaseId: number;
};

export type LawsuitInfo = {
  title: string;
  id: number;
  type: LawsuitItemType;
  actionType: string;
  responsible: string;
  numberCase: string;
  judgment: string;
  court: string;
  courtInfo: string;
  customers: CaseCustomer[];
  stakeholder: Stakeholder[];
  attachments: LawsuitAttachment[];
  convictionAmount: string;
  instanceNumber: number;
  status: "ACTIVE" | "INACTIVE";
  appealIncidents: LawsuitAppealIncident[];
  observation?: string;
  description?: string;
};

type MovementCaseType =
  | "CTE_INCIDENT"
  | "CTE_APPEAL"
  | "CTE_LAWSUIT"
  | "CTE_CONSLTING"
  | "CTE_CASE";

export type Movement = {
  id: number;
  automatic: boolean;
  caseType: MovementCaseType;
  createdAt: number;
  parentCaseId: number;
  rootCaseId: number;
  lawsuit: {
    openDate: number;
    instanceNumber: number;
    lawsuitTypeName: string;
    status?: "ACTIVE" | "INACTIVE";
  };
};

export type MovementResponse = {
  movements: Movement[];
};

export type HistoricalType = "AUTOMATIC_LAWSUIT" | "DONE_TASK" | "MANUALLY" | "CLIPPING";

export type HistoricalTypeMap = {
  [Property in HistoricalType]: string;
};

export type HistoricalEvent = {
  description: string;
  type: HistoricalType;
  responsibleName: string;
  date?: string;
};

export type Historical = {
  id: number;
  date: string;
  description: string;
  descriptionTranslation?: string;
  type: HistoricalType;
  responsibleName: string;
  events: HistoricalEvent[];
};

export type HistoricalResponse = {
  historicals: Historical[];
  cursor: string;
};

export const historicalEventTypeMap: HistoricalTypeMap = {
  AUTOMATIC_LAWSUIT: "Andamento automático",
  CLIPPING: "Publicação",
  DONE_TASK: "Tarefa concluída",
  MANUALLY: "Histórico manual",
};
